import { render, staticRenderFns } from "./courseNote.vue?vue&type=template&id=a5626534&"
import script from "./courseNote.vue?vue&type=script&lang=js&"
export * from "./courseNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports